export default {
    'confirmed': 'Potwierdzona',
    'cancelled': 'Anulowana',
    'settled': 'Rozliczona',
    'finished': 'Zakończona',
    'rejected': 'Odrzucona',
    'waiting_for_client_approval': 'Oczekuje na potwierdzenie klienta',
    'waiting_for_partner_approval': 'Oczekuje na potwierdzenie biznesu'
}